<template>
  <el-dialog :title="id ? '编辑班组' : '新增班组'" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
    <el-form ref="formData" class="global-form2" :model="info" :rules="rules" label-position="right"
      label-width="110px">
      <el-form-item label="所属项目" prop="projectId">
        <el-select v-model="info.projectId" filterable placeholder="请选择所属项目">
          <el-option v-for="item in normalProjectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="teamName" label="班组名称">
        <el-input v-model="info.teamName" placeholder="请输入班组名称" maxlength="30" />
      </el-form-item>
      <el-form-item prop="teamLeader" label="班组负责人">
        <el-input v-model="info.teamLeader" placeholder="请输入班组负责人" maxlength="10" />
      </el-form-item>
      <el-form-item prop="teamLeaderPhone" label="负责人电话">
        <el-input v-model="info.teamLeaderPhone" placeholder="请输入负责人电话" maxlength="30" />
      </el-form-item>
      <el-form-item label="所属供应商" prop="supplierId">
        <el-select v-model="info.supplierId" filterable placeholder="请选择所属供应商">
          <el-option v-for="item in supplierData" :key="item.supplierId" :label="item.supplierName"
            :value="item.supplierId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合作模式" prop="laborModel">
        <el-radio-group v-model="info.laborModel">
          <el-radio label="1">包工模式</el-radio>
          <el-radio label="2">点工模式</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="劳务单价" v-if="info.laborModel === '2'" prop="laborPrice">
        <el-input placeholder="请输入内容" v-model="info.laborPrice">
          <template slot="append">{{ info.laborModel === '1' ? '元/月' : '元/天' }}</template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveForm" :disabled='submitShow'>保存</el-button>
        <el-button @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { phone, validateInteger } from '@/utils/validate'

export default {
  name: 'AddBase',
  props: {
    addShow: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      info: {
        // 基础信息
        projectId: '',
        teamName: '',
        teamLeader: '',
        teamLeaderPhone: '',
        supplierId: '',
        cooperationModel: '',
        laborModel: '1',
        laborPrice: ''
      },

      supplierData: [],
      submitShow: false,

      rules: {
        projectId: [
          { required: true, message: '请选择所属项目', trigger: 'change' }
        ],
        teamName: [
          { required: true, message: '请输入班组名称', trigger: 'change' }
        ],
        teamLeader: [
          { required: true, message: '请输入班组负责人', trigger: 'change' }
        ],
        teamLeaderPhone: [
          { validator: phone },
          { required: true, message: '请输入负责人电话', trigger: 'change' }
        ],
        supplierId: [
          { required: true, message: '请选择所属供应商', trigger: 'change' }
        ],
        laborPrice: [
          { validator: validateInteger }
        ]
      },
      dialogVisible: false
    }
  },
  computed: {

    normalProjectList() {
      return this.$store.state.projectList
    }

  },
  watch: {
    id(val) {
      val && this.getDetail()
    },
    addShow(val) {
      this.dialogVisible = val
    }
  },

  created() {
    this.loadSupplierType() // 加载供应商
  },
  methods: {

    loadSupplierType() {
      this.$axios.get(this.$apis.material.selectYhSupplierByPage).then(res => {
        this.supplierData = res.list
      })
    },

    getDetail() {
      this.$axios.get(this.$apis.laborManage.selectYhTeamByTeamId, { teamId: this.id }).then(res => {
        if (res) {
          this.info = res
        }
      })
    },

    saveForm() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.submitShow = true
          const urls = this.id ? this.$apis.laborManage.updateYhTeam : this.$apis.laborManage.insertYhTeam
          this.$axios.post(urls, this.info).then(() => {
            this.$message.success('保存成功')
            this.handleClose()
            this.$emit('success')
          }).finally(() => {
            this.submitShow = false
          })
        }
      })
    },

    handleClose() {
      this.$emit('update:addShow', false)
      this.$emit('update:id', '')
      this.info = {
        // 基础信息
        projectId: '',
        teamName: '',
        teamLeader: '',
        teamLeaderPhone: '',
        supplierId: '',
        cooperationModel: ''
      }
      this.$refs.formData.resetFields()
    }
  }

}
</script>

<style scoped lang="scss">
.global-form2 .el-textarea {
  width: 380px;
}
</style>
